<template>
    <c-dialog ref="dialog" title="上门服务记录单详情" mode="slide" width="80vw" enable-flex mask-close :button="false">
        <template #head>
            <div v-if="detailData.service_record_number" class="m-detail-tag flex-center-cross">
                <label>{{detailData.service_record_number}}</label>
                <c-state v-if="detailData.status == -1" tag hollow color="#999">草稿</c-state>
                <c-state v-if="detailData.status == 2" tag color="green">已提交</c-state>
            </div>
        </template>

        <module>
            <module-col size="400">
                <c-detail class="m-detail-form">
                    <c-detail-item label="关联售后工单">
                        <c-link v-if="auth('b_aftersale_order_query')" @click="globalDialog('afterSaleOrderDetail', {props: {id: detailData.order_id}})">{{detailData.order_number}}</c-link>
                        <span v-else>{{detailData.order_number}}</span>
                    </c-detail-item>
                    <c-detail-item label="关联售后申请单">
                        <c-link v-if="auth('b_aftersale_apply_view')" @click="globalDialog('aftersaleApplyDetail', {props: {id: detailData.apply_id}})">{{detailData.aftersale_apply_no}}</c-link>
                        <span v-else>{{detailData.apply_order_code}}</span>
                    </c-detail-item>
                    <c-detail-item label="客户名称">
                        {{detailData.customer_name}}
                    </c-detail-item>
                    <c-detail-item label="服务类型">
                        <c-state dict="serviceTypeDic" :value="detailData.service_type"></c-state>
                    </c-detail-item>
                    <c-detail-item label="售后类型">
                        <c-state dict="afterSaleTypeDic" :value="detailData.aftersale_type"></c-state>
                    </c-detail-item>
                    <c-detail-item label="销售部门编号">
                        {{detailData.sale_dept_code || '-'}}
                    </c-detail-item>
<!--                    <c-detail-item label="起始地址">-->
<!--                        {{detailData.start_address || '-'}}-->
<!--                    </c-detail-item>-->
                    <c-detail-item label="客户地址">
                        {{detailData.customer_address || '-'}}
                    </c-detail-item>
                    <c-detail-item label="城市">
                        {{detailData.city || '-'}}
                    </c-detail-item>
                    <c-detail-item label="公里数">
                        {{detailData.kilometers}}公里
                    </c-detail-item>
                    <c-detail-item label="人员到达时间">
                        {{detailData.arrive_time || '-'}}
                    </c-detail-item>
                    <c-detail-item label="是否收费">
                        <c-state dict="isChargeDic" :value="detailData.is_charge"></c-state>
                    </c-detail-item>
                    <c-detail-item label="是否派车">
                        <c-state dict="isChargeDic" :value="detailData.is_send_car"></c-state>
                    </c-detail-item>
                    <c-detail-item label="是否使用机台">
                        <c-state dict="isChargeDic" :value="detailData.is_use_machine"></c-state>
                    </c-detail-item>
                    <c-detail-item label="是否完成">
                        <c-state dict="isChargeDic" :value="detailData.is_finish"></c-state>
                    </c-detail-item>
                    <c-detail-item label="服务天数">
                        {{detailData.service_days || '0'}}天
                    </c-detail-item>
                    <c-detail-item label="正常日天数">
                        {{detailData.normal_days || '0'}}天
                    </c-detail-item>
                    <c-detail-item label="休息日天数">
                        {{detailData.holiday_days || '0'}}天
                    </c-detail-item>
                    <c-detail-item label="节日天数">
                        {{detailData.festival_days || '0'}}天
                    </c-detail-item>
                    <c-detail-item label="住宿天数">
                        {{detailData.accommodation_days || '0'}}晚
                    </c-detail-item>
                    <c-detail-item label="交通费">
                        ￥{{detailData.traffic_fee || '0'}}
                    </c-detail-item>
                    <c-detail-item label="车辆费用">
                        ￥{{detailData.vehicle_fee || '0'}}
                    </c-detail-item>
                    <c-detail-item label="设备费用">
                        ￥{{detailData.machine_fee || '0'}}
                    </c-detail-item>
                    <c-detail-item label="员工费用">
                        ￥{{detailData.staff_fee || '0'}}
                    </c-detail-item>

                    <c-detail-item label="总金额">
                        ￥{{detailData.total_amount || '0'}}
                    </c-detail-item>
                    <c-detail-item label="通知单金额">
                        ￥{{detailData.notice_amount || '0'}}
                    </c-detail-item>
                    <c-detail-item label="上门服务人员费用">
                        ￥{{detailData.onsite_service_fee || '0'}}
                    </c-detail-item>
                    <c-detail-item label="服务内容">
                        {{detailData.service_content || '-'}}
                    </c-detail-item>
                    <c-detail-item label="备注">
                        {{detailData.remark || '-'}}
                    </c-detail-item>
                    <c-detail-item label="创建人">
                        {{detailData.create_user_realname}}
                    </c-detail-item>
                    <c-detail-item label="创建时间">
                        {{detailData.create_date}}
                    </c-detail-item>
                    <custom-detail ref="customDetail" work-type="15" :data="detailData.custom_fields_value_json"></custom-detail>
                </c-detail>
            </module-col>

            <module-col tab-type="border-tab">
                <module-tab name="服务明细" enable-flex>
                    <div class="m-detail-box">
                        <c-table ref="itemListTable" :data="itemList" border :paging="false">
                            <c-table-column label="产品编码" width="100">
                                <template #default="{data}">
                                    <span>{{data.product_code || '-'}}</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="规格型号" width="120">
                                <template #default="{data}">
                                    <span>{{data.spec_model || '-'}}</span>
                                </template>
                            </c-table-column>
                            <c-table-column label="接头方式" width="100">
                                <template #default="{data}">

                                    <c-state dict="connectionMethodDic" :value="data.connection_method"></c-state>
                                </template>
                            </c-table-column>
                            <c-table-column label="长(mm)" width="80">
                                <template #default="{data}">
                                    <span>{{data.length ?? '-'}}</span>
                                </template>
                            </c-table-column>
                            <c-table-column label="宽(mm)" width="80">
                                <template #default="{data}">
                                    <span>{{data.width ?? '-'}}</span>
                                </template>
                            </c-table-column>
                            <c-table-column label="件数" width="80">
                                <template #default="{data}">
                                    <span>{{data.pieces ?? '-'}}</span>
                                </template>
                            </c-table-column>
                            <c-table-column label="平方米" width="80">
                                <template #default="{data}">
                                    <span>{{data.quantity ?? '-'}}</span>
                                </template>
                            </c-table-column>

                        </c-table>
                    </div>
                </module-tab>

                <module-tab name="服务人员" enable-flex>
                    <div class="m-detail-box">
                        <c-table ref="memberListTable" :data="memberList" border :paging="false">
                            <c-table-column label="姓名" width="100">
                                <template #default="{data}">
                                    <span>{{data.user_realname || '-'}}</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="费用" width="120">
                                <template #default="{data}">
                                    <span>￥{{data.fee || '-'}}</span>
                                </template>
                            </c-table-column>
                        </c-table>
                    </div>
                </module-tab>
            </module-col>
        </module>
    </c-dialog>
</template>

<script>
import {mapState} from 'vuex';

export default {
    name: 'visitServiceDetail',

    props: {
        id: [String, Number]
    },

    data() {
        return {
            detailData: {},
            itemList: [],
            memberList: []
        }
    },

    computed: {
        ...mapState(['serviceTypeDic', 'afterSaleTypeDic', 'isChargeDic', 'isSendCarDic', 'useMachineOptions'])
    },

    methods: {
        detail() {
            this.request({
                url: '/aftersale/visit_service/detail',
                data: {
                    id: this.id
                },
                loading: true,
                success: data => {
                    this.detailData = data.detailInfo;
                    this.itemList = data.itemList || [];
                    this.memberList = data.memberList || [];
                    this.$refs.customDetail.init();
                }
            });
        },

        open() {
            this.detail();
            this.$refs.dialog.open();
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>
